import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { routes } from "@/routes/baseRoutes";
import "./index.css";

import globalStore from '@/store/store'
import { setDeviceAction } from "@/store/global"

import { createNotificationContext } from "@/libraries/notification/NotificationContext"
import { useNotificationManager } from "@/libraries/notification/NotificationManager"
import { NOTIFICATION } from "@/constants"

import {
  setErrorAction,
  setLoadingAction,
  setUserDataAction,
} from "./store/user/user";

import { getUserDetails } from "./services/rest/user-details";


import { navigateToSSO } from "@/utility/navigate"
import { getClientCode } from "@/utility/getClientCode";
import { clearCookie } from "@/utility/clearCookie";
import { useResponsiveScreen } from "@/utility/device"
import Sentry from "@/utility/errorTracking";

import ErrorPage from "@/pages/ErrorPage.jsx";

import Spinner from '@/components/units/Spinner';

const clientCode = getClientCode();
if (!clientCode) {
  navigateToSSO()
} else {
  Sentry.setUser({
    id: clientCode || "NULL",
  });
}

const router = createBrowserRouter(routes, {
  basename: "/dashboard"
});

const NotificationContext = createNotificationContext(NOTIFICATION.NOTIFICATION)
const ToastContext = createNotificationContext(NOTIFICATION.TOAST)

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <div className="app-loading-container">
      <Spinner />
    </div>
  </React.StrictMode>
);

const fetchUserDetails = async () => {
  try {
    globalStore.dispatch(setLoadingAction(true));
    // globalStore.dispatch(setBankLoadingAction(true));
    const userdetails = await getUserDetails();
    if (userdetails.uniqueCientCode === clientCode) {
      globalStore.dispatch(setUserDataAction(userdetails));
      root.render(
        <App />
      );
    } else {
      throw "SESSION_CLIENT_CODE_MISMATCH";
    }
  } catch (error) {
    globalStore.dispatch(setErrorAction(error.message));
    // globalStore.dispatch(setBankLoadingAction(false));
    clearCookie("llt");
    console.error("Error initialising the app", error);
    navigateToSSO()
  } finally {
    globalStore.dispatch(setLoadingAction(false));
  }
};

const App = () => {
  const appNotification = useNotificationManager()
  const appToast = useNotificationManager()

  useResponsiveScreen((deviceSizeMatrix) => {
    globalStore.dispatch(setDeviceAction(deviceSizeMatrix));
  });

  return (
    <React.StrictMode>
      <Sentry.ErrorBoundary
        fallback={<ErrorPage />}
      >
        <Provider store={globalStore}>
          <NotificationContext.Provider value={appNotification}>
            <ToastContext.Provider value={appToast}>
              <RouterProvider router={router} />
            </ToastContext.Provider>
          </NotificationContext.Provider>
        </Provider>
      </Sentry.ErrorBoundary>
    </React.StrictMode>
  );
};

fetchUserDetails();

// TODO:
// Sentry Router Error
